import React, { Component } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
export default class FluencyLetterS extends Component {
  render() {
    var {
      fluecy_letter_s_stop_watch_1,
      noOfWords,
      flu_s_part_1_note,
      fluecy_letter_s_stop_watch_2,
      fluency_ls_score,
      letter_s_no_of_words,
      fluency_ls_score,
      letter_s_spoken_total,
      fluency_letter_s_words,
      letter_s_no_of_words,
    } = this.props.data;
    let no_of_words = fluency_letter_s_words
      ? JSON.parse(fluency_letter_s_words)
      : [];
    let total_spoken =
      (60 -
        (fluecy_letter_s_stop_watch_2 == 60
          ? 0
          : Number(fluecy_letter_s_stop_watch_2))) /
      parseFloat(letter_s_no_of_words);
    return (
      <div className="row border border-dark bg-white">
        <div className="col-lg-10 pt-2">
          
        </div>
        <div className="col-lg-2 pt-2" style={{ borderLeft: "1px solid #000" }}>
          <br />
          <span className="fs-19">Score (0 - 12) </span>
          <input
            name="fluency_ls_score"
            onChange={this.handleChange}
            type="number"
            className="ecas-input-field"
            placeholder="Score"
            value={fluency_ls_score}
          />
        </div>
      </div>
    );
  }
}
